import { DOC_TYPES, HOME_SLUG } from '@/data'
import styles from './FourOhFour.module.scss'
import AnimatedTextLines from '@/components/AnimatedTextLines/AnimatedTextLines'
import { useEffect, useRef } from 'react'
import Link from '@/components/Link/Link'

const FourOhFour = () => {
  const animatedLinkLinesRef = useRef(null)
  const animatedTitleLinesRef = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      animatedLinkLinesRef.current.animate()
      animatedTitleLinesRef.current.animate()
    }, 500)
  }, [])

  return (
    <div className={styles.FourOhFour}>
      <div className={styles.inner}>
        <h1 className={styles.title}>
          <AnimatedTextLines
            className={styles.linkText}
            querySelector="span"
            toAnimate="lines"
            autoAnimate={false}
            animateInConfig={{
              duration: 1.4,
            }}
            ref={animatedTitleLinesRef}
          >
            <span className={styles.title__span}>404 Error Can’t Find</span>
          </AnimatedTextLines>
        </h1>
        <Link
          link={{
            linkType: 'internal',
            link: {
              slug: HOME_SLUG,
              _type: DOC_TYPES.PAGE,
            },
          }}
          className={styles.link}
        >
          <AnimatedTextLines
            className={styles.linkText}
            querySelector="span"
            toAnimate="lines"
            autoAnimate={false}
            animateInConfig={{
              delay: 0.35,
            }}
            ref={animatedLinkLinesRef}
          >
            <span className={styles.linkText__span}>Go Home</span>
          </AnimatedTextLines>
        </Link>
      </div>
    </div>
  )
}

FourOhFour.displayName = 'FourOhFour'

export default FourOhFour
